module.exports = __webpack_public_path__ + "media/images/corporate-logos/logo-step-2-ec1c700a38f0ef456d562c68874427d3.svg";